import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { IStatuses } from './statuses.types';

const PREFIX = 'RECIPIENT/STATUSES';

export const loadStatusesRequest = createAction<IBaseRequestParams>(`${PREFIX}/LOAD_STATUSES_REQUEST`);
export const loadStatusesSuccess = createAction<IStatuses>(`${PREFIX}/LOAD_STATUSES_SUCCESS`);
export const loadStatusesFail = createAction<TLegacyErrors>(`${PREFIX}/LOAD_STATUSES_FAIL`);

export const updateStatuses = createAction<Partial<IStatuses>>(`${PREFIX}/UPDATE_STATUSES`);
